"use strict";

angular.module("vendor")
.directive("mainLayout", [function() {
    return {
        templateUrl: require("vendor/layout/layout.html"),
        css: [require("vendor/layout/layout.css")]
    };
}]);



//////////////////
// WEBPACK FOOTER
// ./vendor/layout/layout.directive.js
// module id = 789
// module chunks = 0